<template>
  <div class="navbar-top flx-row js-btw">
    <el-dialog
      :title="$t('login.title')"
      :visible.sync="dialogVisible"
      width="20%"
      center
      :close-on-click-modal="false"
      @close="handleClose"
    >
      <div class="flx-row">
        <img src="static/img/log_icon_account.png" alt />
        <el-input
          :placeholder="$t('login.placeholders[0]')"
          clearable
          v-model="inputAcc"
        ></el-input>
      </div>
      <div class="flx-row mt-20">
        <img src="static/img/log_icon_cipher.png" alt />
        <el-input
          :placeholder="$t('login.placeholders[1]')"
          show-password
          v-model="inputPass"
        ></el-input>
      </div>
      <div class="bg-e0 mt-40 tal-ct c-f fs-18 csr-pt" @click="tologin">
        {{ $t("login.title") }}
      </div>
      <div class="dialog-footer fs-12 c-6" slot="footer">
        <div class="flx-row">
          <div class="csr-pt" @click="toRegister">
            {{ $t("login.oper[0]") }}
          </div>
          <div class="mgl-20 csr-pt" @click="fogetPass">
            {{ $t("login.oper[1]") }}
          </div>
        </div>
      </div>
    </el-dialog>
    <div class="top-left c-e0 flx-row">
      <div class="flx-row">
        <img src="../../../static/img/home_icon_news.png" alt />
        <swiper :options="swiperOption" ref="mySwiper" v-if="navList.length">
          <!-- slides -->
          <swiper-slide v-for="(item, index) in navList" :key="index">
            <div
              class="fs-12 mgl-10 csr-pt"
              @mouseleave="onStart"
              @mouseenter="onStop"
              @click="toAnno"
            >
              {{ item.title }}
            </div>
          </swiper-slide>
          <!-- Optional controls -->
        </swiper>
      </div>
    </div>
    <div class="top-right flx-row fs-14">
      <div class="flx-row bdr-d6 pdlr-20" v-if="isLogin">
        <div class="csr-pt" @click="toPer">{{ mailAccount }}</div>
        <div class="mgl-10 csr-pt" @click="logOut">
          {{ $t("Layout.logOut") }}
        </div>
      </div>
      <div class="flx-row bdr-d6 pdlr-20" v-else>
        <div class="csr-pt" @click="showLogin">{{ $t("Layout.logIn") }}</div>
        <div class="mgl-10 csr-pt" @click="toRegister">
          {{ $t("Layout.register") }}
        </div>
      </div>
      <el-popover placement="top-start" width="230" trigger="click">
        <div slot class="_outter">
          <div class="_inner">
            <div
              v-if="messageList.length == 0"
              align="center"
              class="c-9 mt-20"
            >
              {{ $t("Layout.messageEmpty") }}
            </div>
            <div
              class="mess-container"
              v-for="(item, index) in messageList"
              :key="index"
              v-else
            >
              <div class="circle"></div>
              <div class="c-6" :class="index > 0 ? 'mt-10' : ''">
                {{ item.content }}
              </div>
            </div>
          </div>
        </div>
        <div slot="reference" class="bdr-d6 pdlr-20">
          <p class="csr-pt">{{ $t("Layout.message") }}</p>
        </div>
      </el-popover>

      <div class="bdr-d6 pdlr-20">
        <p class="csr-pt" @click="myorder">{{ $t("Layout.myOrders") }}</p>
      </div>
      <div class="bdr-d6 pdlr-20">
        <p class="csr-pt" @click="toFavor">{{ $t("Layout.myFavor") }}</p>
      </div>
      <div class="pdlr-20 flx-row">
        <div class="csr-pt flx-row">
          <!-- <div>简体中文</div>
          <img class="mgl-10" src="/static/img/public_icon_lower.png" alt>-->
          <el-dropdown @command="changeLang" trigger="click">
            <span class="el-dropdown-link flx-row">
              {{ $t("Layout.currentLan") }}
              <img class="mgl-10" src="static/img/public_icon_lower.png" alt />
            </span>
            <el-dropdown-menu slot="dropdown" class="flx-col">
              <el-dropdown-item command="zhCN">简体中文</el-dropdown-item>
              <el-dropdown-item command="zhTW">繁體中文</el-dropdown-item>
              <el-dropdown-item command="en">English</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAnnouncement } from "@/api/announcement";
import { getNotice } from "@/api/homepage";
import { login } from "@/api/login";
import signature from "@/utils/signature";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { setTimeout } from "timers";
export default {
  watch: {
    "$store.state.showLoginPad": "setLo",
    "$store.state.showRegi": "showRegis",
    "$i18n.locale": "getMessage",
    "$i18n.locale": "getAnno",
  },
  data() {
    return {
      isLogin: false,
      swiperOption: {
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        // ...
        observer: true,
        observeParents: true,
        spaceBetween: 1,
        direction: "vertical",
        autoplay: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: true,
        },
        autoHeight: true,
        height: "20",
        // loop: true
        // delay: "500"
      },
      mailAccount: "",
      inputAcc: "",
      inputPass: "",
      dialogVisible: false,
      messageList: [],
      navList: [],
    };
  },
  computed: {
    mySwiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  beforeMount() {
    if (localStorage.getItem("accessToken")) {
      // console.log(this.$store.state.account);
      this.mailAccount = localStorage.getItem("account");
      this.isLogin = true;
    } else {
      this.isLogin = false;
    }
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      this.getMessage();
      //请求消息
      this.getAnno();
    },
    getAnno() {
      console.log(this.$i18n.locale);
      //进来首页渲染公告的请求
      let query = {
        page: 1,
        number: 10,
        lang: this.$store.state.conty,
      };
      getAnnouncement(query).then((res) => {
        if (res.data.list.length > 0) {
          this.navList = res.data.list;
        }
      });
    },
    getMessage() {
      if (localStorage.getItem("accessToken")) {
        // this.messageList = [
        //   "您的商品UFO飞碟可以进行尾款补齐",
        //   "您已经一个月未消费，将扣除500积分"
        // ];
        getNotice().then((res) => {
          if (res.code == 200) {
            console.log(res);
            this.messageList = res.data.list;
          }
        });
      } else {
        this.messageList = [{ content: this.$t("public.loginstatus") }];
      }
    },
    showRegis() {
      this.isLogin = this.$store.state.showRegi;
      this.mailAccount = localStorage.getItem("account");
    },
    toAnno() {
      this.$router.push({
        path: "/announcement",
      });
    },
    setLo() {
      // this.dialogVisible = true;
      if (this.$store.state.showLoginPad == true) {
        this.dialogVisible = true;
      } else {
        this.dialogVisible = false;
      }
    },
    handleClose() {
      this.$store.commit("changeShowLogin", false);
    },
    changeLang(e) {
      switch (e) {
        case "zhCN":
          this.$i18n.locale = "cn";
          // this.$store.state.conty = "zh-cn";
          this.$store.commit("changeConty", "zh-cn");
          break;
        case "zhTW":
          this.$i18n.locale = "tw";
          // this.$store.state.conty = "zh-hk";
          this.$store.commit("changeConty", "zh-hk");
          break;
        case "en":
          this.$i18n.locale = "en";
          // this.$store.state.conty = "eng";
          this.$store.commit("changeConty", "eng");
          break;

        default:
          break;
      }
    },
    showLogin() {
      this.dialogVisible = true;
    },
    toRegister() {
      this.dialogVisible = false;
      this.$router.push({
        path: "/register",
      });
    },
    toAnnouncement() {
      this.$router.push({
        path: "/announcement",
      });
    },
    fogetPass() {
      this.dialogVisible = false;
      this.$router.push({
        path: "/recovery",
      });
    },
    toFavor() {
      this.$router.push({
        path: "/favor",
      });
    },
    tologin() {
      // console.log(this.inputAcc);
      // console.log(this.inputPass);
      let postData = {
        account: this.inputAcc,
        password: signature.Encrypt(this.inputPass),
      };
      login(postData).then((res) => {
        let pathName = sessionStorage.getItem("pathname");
        // console.log(pathName);
        if (res.code == 200) {
          localStorage.setItem("accessToken", res.data.token);
          localStorage.setItem("account", this.inputAcc);
          this.inputAcc = "";
          this.inputPass = "";
          this.$store.commit("changeRegi", true);
          this.dialogVisible = false;
          this.getMessage();
          this.$router.push({
            path: "/",
          });
          // setTimeout(location.reload(), 2000);
          // 跳转登录
        }
      });
    },
    onStart() {
      this.mySwiper.autoplay.start();
    },
    onStop() {
      this.mySwiper.autoplay.stop();
    },
    myorder() {
      this.$router.push({
        path: "/orders",
      });
    },
    toPer() {
      this.$router.push({
        name: "personal",
      });
    },
    clear() {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("account");
      this.$store.commit("changeRegi", false);
      this.$router.push({
        path: "/",
      });
    },
    async logOut() {
      await this.clear();
      setTimeout(location.reload(), 1000);
    },
  },
  components: {
    swiper,
    swiperSlide,
  },
};
</script>
<style lang="scss">
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background: #eee;
  color: #666;
}
.navbar-top {
  .el-dialog {
    position: absolute;
    top: 50%;
    margin: 0 auto !important;
    transform: translate(-50%, -50%);
    left: 50%;
    .el-dialog__title {
      font-size: 1.5rem;
      font-weight: bold;
    }
    .el-dialog__headerbtn:focus .el-dialog__close,
    .el-dialog__headerbtn:hover .el-dialog__close {
      color: #e09e0b;
    }
    .el-dialog__headerbtn .el-dialog__close {
      font-size: 1.3125rem;
    }
    .el-dialog__footer {
      padding: 0;
      background: #f0f0f0;
      .flx-row {
        justify-content: flex-end;
        padding: 1rem 1.25rem;
      }
    }
    .el-dialog--center .el-dialog__body {
      // padding: 0 !important;
    }
    .el-dialog__body {
      padding-top: 3.125rem;
      padding-left: 3.125rem;
      padding-right: 3.125rem;
      .flx-row {
        border: 0.0625rem solid #d7d7d7;
        img {
          border-right: 0.0625rem solid #d7d7d7;
          padding: 0 0.6875rem;
        }
      }
      .fs-18 {
        padding: 0.75rem 0;
      }
    }
  }
  .el-input__inner {
    border: none !important;
  }
}
</style>

<style lang="scss" scoped>
._outter {
  height: 300px;
  overflow: hidden;
  ._inner {
    height: 300px;
    overflow-x: hidden;
    overflow-y: scroll;
  }
  ._inner::-webkit-scrollbar {
    display: none;
  }
}

.navbar-top {
  background: #333;
  padding: 0.625rem 22.8125rem;
  .top-right {
    color: #d6d6d6;
    .el-dropdown {
      color: #d6d6d6;
    }
  }
}
.mess-container {
  padding: 0.625rem 0;
  align-items: center;
  display: flex;
  flex-direction: row;
  .circle {
    width: 0.3125rem;
    height: 0.3125rem;
    border-radius: 50%;
    background: #666;
  }
  .c-6:hover {
    color: #e09e0b;
  }
  .c-6 {
    padding: 0 1.25rem;
    cursor: default;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/navbar/navtop.vue